module.exports = __webpack_public_path__ + "img/navigation-next-alternate.098fafa6.svg";